<template>
  <div>
    <div id="quotationListPage">
      <!-- <div class="quotationTitle">
        <div class="title">行情列表</div>
      </div> -->
      <div class="centerWrap">
        <div class="goods_choose">
          <div class="goods_choose_box">
            <div class="goods_self_choose" :class="isAllSelectStyle?'select':''" @click="allSelectlctClick()">所有商品</div>
            <!-- <div class="goods_self_choose" :class="isSelfSelectStyle?'select':''" @click="selfSeelctClick()">自选商品</div> -->
            <div v-for="(item,i) in classNames" :key="`goods_tabs_cell-${i}`" :class="selectClass.topId==item.topId?'select':''" class="goods_self_choose" @click="changeSelectClass(item)">{{ item.className }}</div>
          </div>
        </div>
      </div>
      <!-- 行情列表页 -->
      <div class="quotation-header">
        <!-- :row-class-name="txtRowClass" -->
        <!-- height="856" -->
        <el-table
          :data="newmarketDetails"
          stripe
          style="width:100%;cursor:pointer;background:#FFF"
          :header-cell-style="{ background: '#FAFAFA' }"
          :cell-class-name="txtClass"
          :header-cell-class-name="nameStyle"
          @row-click="markets"
          @cell-dblclick="goTranscc"
          @sort-change="sortChangeF"
        >
          <el-table-column
            align="center"
            width="85"
          >
            <template slot-scope="scope">
            </template>
          </el-table-column>
          <el-table-column
            align="right"
            width="85"
          >
            <template slot-scope="scope">
              <!-- <span @click.stop="changeSelfSelect(scope.row.symbolId,scope.row._isSelfSelect)">
                <img v-if="!scope.row._isSelfSelect" src="../../assets/images/_isSelfSelect.png" alt="">
                <img v-else src="../../assets/images/_noSelfSelect.png" alt="">
              </span> -->
            </template>
          </el-table-column>
          <el-table-column prop="open" align="center" :label="'商品代码'">
            <template slot-scope="scope">
              <div>{{ scope.row.commodityCode }}</div>
              <!-- <div class="goldColor">{{ scope.row.commodityCode }}</div> -->
            </template>
          </el-table-column>
          <el-table-column
            prop="symbol"
            align="center"
            label="商品名称"
            width="140"
          >
            <template slot-scope="scope">
              <div>
              <!-- <div class="goldColor"> -->
              <!-- <div class="goldColor" style="display:flex;align-items: center;justify-content: flex-start;"> -->
                <!--  :class="scope.row.contractMarkFlag == 0 ? 'notFree' : 'optional'"<span
                @click.stop="changeSelfSelect(scope.row.symbolId,scope.row._isSelfSelect)"
              ><i class="el-icon-star-on" :class="scope.row._isSelfSelect ? 'selfSeelctSymbol' : ''"></i></span> -->
                {{ scope.row.symbol }}
                <!-- <span v-if="scope.row.isMain" class="mainForce">主力</span> -->
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="symbol"
            align="center"
            label=""
            width="70"
            sortable="custom"
          >
            <template slot-scope="scope">
              <div class="goldColor" style="display:flex;align-items: center;justify-content:center">
                <img v-if="sortOrder==='ascending'" src="../../assets/images/ruy.png">
                <img v-if="sortOrder==='descending'" src="../../assets/images/jt1.png">
                <span v-if="scope.row.isMain" class="mainForce">主力</span>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="open" align="center" :label="'开盘价'">
            <template slot-scope="scope">
              <div>{{ Number(scope.row.open) === 0 ? '--' : Number(scope.row.open).toFixed(scope.row.coinDigitalNum) }}</div>
              <!-- <div :class="Number(scope.row.open)==0?'':(Number(scope.row.open)>Number(scope.row.clearPrice)?'redColor':Number(scope.row.open)<Number(scope.row.clearPrice)?'greenColor':'whiteColor')">{{ Number(scope.row.open) === 0 ? '--' : Number(scope.row.open).toFixed(scope.row.coinDigitalNum) }}</div> -->
            </template>
          </el-table-column>
          <el-table-column prop="close" align="center" :label="'最新'">
            <template slot-scope="scope">
              <!-- <div>{{ Number(scope.row.close).toFixed(scope.row.coinDigitalNum) }}</div> -->
              <div :style="{color:scope.row.closeToClearColor1}">{{ Number(scope.row.close).toFixed(scope.row.coinDigitalNum) }}</div>
              <!-- <div style="color:#d94066;">{{ Number(scope.row.close).toFixed(scope.row.coinDigitalNum) }}</div> -->
            </template>
          </el-table-column>
          <el-table-column
            prop="quote"
            align="center"
            label="涨跌"
          >
            <template slot-scope="scope">
              <!-- eslint-disable-next-line vue/valid-v-bind -->
              <!-- <div>{{ Number(scope.row.quote).toFixed(scope.row.coinDigitalNum) }}&nbsp;&nbsp;</div> -->
              <div :style="{color:scope.row.closeToClearColor1}">{{ Number(scope.row.quote).toFixed(scope.row.coinDigitalNum) }}&nbsp;&nbsp;</div>
              <!-- <div style="color:#d94066;">{{ Number(scope.row.quote).toFixed(scope.row.coinDigitalNum) }}&nbsp;&nbsp;</div> -->
            </template>
          </el-table-column>
          <el-table-column
            prop="quotechange"
            align="center"
            label="幅度"
          >
            <template slot-scope="scope">
              <div :style="{color:scope.row.quotechangeColor1}">{{ scope.row.quotechange | addSign }}&nbsp;&nbsp;</div>
  
            </template>
          </el-table-column>
          <el-table-column
            prop="high"
            align="center"
            label="最高价"
          >
            <template slot-scope="scope">
              <!-- <div>{{ Number(scope.row.high)==0?'--':Number(scope.row.high).toFixed(scope.row.coinDigitalNum) }}</div> -->
              <div :class="Number(scope.row.high)==0?'':(Number(scope.row.high)>Number(scope.row.clearPrice)?'redColor':Number(scope.row.high)<Number(scope.row.clearPrice)?'greenColor':'whiteColor')">{{ Number(scope.row.high)==0?'--':Number(scope.row.high).toFixed(scope.row.coinDigitalNum) }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="low"
            align="center"
            label="最低价"
          >
            <template slot-scope="scope">
              <!-- <div>{{ Number(scope.row.low)==0?'--':Number(scope.row.low).toFixed(scope.row.coinDigitalNum) }}</div> -->
              <div :class="Number(scope.row.low)==0?'':(Number(scope.row.low)>Number(scope.row.clearPrice)?'redColor':Number(scope.row.low)<Number(scope.row.clearPrice)?'greenColor':'whiteColor')">{{ Number(scope.row.low)==0?'--':Number(scope.row.low).toFixed(scope.row.coinDigitalNum) }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="clearPrice"
            align="center"
            label="昨结算价"
          >
            <template slot-scope="scope">
              <div>{{ Number(scope.row.clearPrice )==0?'--':Number(scope.row.clearPrice ).toFixed(scope.row.coinDigitalNum) }}</div>
              <!-- <div class="whiteColor">{{ Number(scope.row.clearPrice )==0?'--':Number(scope.row.clearPrice ).toFixed(scope.row.coinDigitalNum) }}</div> -->
            </template>
          </el-table-column>
          <el-table-column
            prop="averagePrice"
            align="center"
            label="均价"
          >
            <template slot-scope="scope">
              <div>{{ Number(scope.row.averagePrice)==0?'--':Number(scope.row.averagePrice).toFixed(scope.row.coinDigitalNum) }}</div>
              <!-- <div :class="Number(scope.row.averagePrice)==0?'':(Number(scope.row.averagePrice)>Number(scope.row.clearPrice)?'redColor':Number(scope.row.averagePrice)<Number(scope.row.clearPrice)?'greenColor':'whiteColor')">{{ Number(scope.row.averagePrice)==0?'--':Number(scope.row.averagePrice).toFixed(scope.row.coinDigitalNum) }}</div> -->
            </template>
          </el-table-column>
          <el-table-column
            prop="yescloseprice"
            align="center"
            label="昨收盘价"
          >
            <template slot-scope="scope">
              <div>{{ Number(scope.row.yescloseprice)==0?'--':Number(scope.row.yescloseprice).toFixed(scope.row.coinDigitalNum) }}&nbsp;&nbsp;</div>
              <!-- <div :class="Number(scope.row.yescloseprice)==0?'':'whiteColor'">{{ Number(scope.row.yescloseprice)==0?'--':Number(scope.row.yescloseprice).toFixed(scope.row.coinDigitalNum) }}&nbsp;&nbsp;</div> -->
            </template>
          </el-table-column>
          <el-table-column
            prop="currencyQuantity"
            align="center"
            label="现量"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.currencyQuantity&&Number(scope.row.currencyQuantity)==0?'--':Number(scope.row.currencyQuantity).toFixed(scope.row.quantityNum) }}</div>
              <!-- <div class="goldColor">{{ scope.row.currencyQuantity&&Number(scope.row.currencyQuantity)==0?'--':Number(scope.row.currencyQuantity).toFixed(scope.row.quantityNum) }}</div> -->
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="quotechange"
            align="center"
            label="买价"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.quotechange }}&nbsp;&nbsp;</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="quotechange"
            align="center"
            label="买量"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.quotechange }}&nbsp;&nbsp;</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="quotechange"
            label="卖价"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.quotechange }}&nbsp;&nbsp;</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="quotechange"
            label="卖量"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.quotechange }}&nbsp;&nbsp;</div>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="amount"
            align="center"
            label="成交量"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.amount&&Number(scope.row.amount)>10000">{{ Number(scope.row.amount)==0?'--':Number(scope.row.amount) | amountFixFormat }}</div>
              <div v-else>{{ Number(scope.row.amount)==0?'--':Number(scope.row.amount).toFixed(scope.row.quantityNum) }}</div>
              <!-- <div v-if="scope.row.amount&&Number(scope.row.amount)>10000" class="flex-col msg r" :class="Number(scope.row.amount)==0?'':'goldColor'">{{ Number(scope.row.amount)==0?'--':Number(scope.row.amount) | amountFixFormat }}</div>
              <div v-else class="flex-col msg r" :class="Number(scope.row.amount)==0?'':'goldColor'">{{ Number(scope.row.amount)==0?'--':Number(scope.row.amount).toFixed(scope.row.quantityNum) }}</div> -->
            </template>
          </el-table-column>
          <el-table-column
            prop="holdQuantity"
            align="center"
            label="存货量"
          >
            <template slot-scope="scope">
              <!-- <div v-if="scope.row.holdQuantity&&Number(scope.row.holdQuantity>10000)">{{ Number(scope.row.holdQuantity) | amountFixFormat }}&nbsp;&nbsp;</div>
              <div v-else>{{ Number(scope.row.holdQuantity).toFixed(scope.row.quantityNum) }}&nbsp;&nbsp;</div> -->
              <div v-if="scope.row.holdQuantity&&Number(scope.row.holdQuantity>10000)">{{ Number(scope.row.holdQuantity) * (APP_WINNY_NAME == '尚志汇农' ? 2 : 1) | amountFixFormat }}&nbsp;&nbsp;</div>
              <div v-else>{{ (Number(scope.row.holdQuantity) * (APP_WINNY_NAME == '尚志汇农' ? 2 : 1)).toFixed(scope.row.quantityNum) }}&nbsp;&nbsp;</div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="85"
          >
            <template slot-scope="scope">
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="85"
          >
            <template slot-scope="scope">
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="totalAmount"
            align="center"
            label="成交金额"
          >
            <template slot-scope="scope">
              <div class="greyColor">{{ Number(scope.row.totalAmount) | amountFixFormat }}&nbsp;&nbsp;</div>
            </template>
          </el-table-column> -->
          <!-- <el-table-column
            prop="turnoverRate"
            align="center"
            label="换手率"
          >
            <template slot-scope="scope">
              <div class="greyColor">{{ scope.row.turnoverRate&&typeof(scope.row.turnoverRate)==='number'? (scope.row.turnoverRate*100).toFixed(2) : '0' }}%&nbsp;&nbsp;</div>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
    </div>
    <!-- <div class="amountWrap">
      <div class="itemData">
        成交量&nbsp;{{ totalAmount.amount }}
      </div>
      <div class="itemData">
        存货量&nbsp;{{ totalAmount.holdQuantity }}
      </div>
      <div class="itemData">
        成交金额&nbsp;{{ totalAmount.totalAmount }}
      </div>
    </div> -->
    <!-- 下单部分 -->
    <!-- <div class="transCC-box7 transCC-box">
      <NewFooter />
    </div> -->
    <cmsEntryAgreement ref="agreementOpen" @confirm="confirmAgree" />
    <enterSimple ref="simpleOpen" @confirm="confirmAgree" />
  </div>
</template>
<script>
/*global http protocol hqWs hqProtocol util*/
import NewFooter from '../transcc/new/NewFooter.vue'
import cmsEntryAgreement from '@/components/base/entryAgreement/cmsEntryAgreement.vue'
import enterSimple from '@/components/base/entryAgreement/enterSimple.vue'
import {
  mapGetters
} from 'vuex'
export default {
  components: {
    NewFooter,
    cmsEntryAgreement,
    enterSimple
  },
  data() {
    return {
      APP_WINNY_NAME: window.g.APP_WINNY_NAME,
      isQianyue: false,
      newmarketDetailsList: [],
      newmarketDetails: [],
      oldmarketlists: [],
      isShow: false,
      isShowAlerady: false,
      totalAssets: 0,
      isHeight: 1,
      searchCurrencyMsg: '',
      timeClick: null,
      closeNum: 0,
      isSelfSelectStyle: false, // 自选状态
      isAllSelectStyle: true, // 全部状态
      selfSelectedGoodsIds: [],
      selectClass: {
        'topId': null,
        'className': null
      },
      selfSelectMarketSymbols: [],
      totalAmount: {
        amount: 0,
        holdQuantity: 0,
        totalAmount: 0
      },
      mainList: [], // 主力合约集合
      sortOrder: null, // 排序状态字段  descending / ascending / null
      userList: null
    }
  },
  computed: {
    ...mapGetters(['sessionInfoGetter', 'marketDetails', 'item', 'tvReadyFlagsGetter']),
    // 分类
    classNames() {
      const classNames = {}
      for (let i = 0; i < this.marketDetails.length; i++) {
        const element = this.marketDetails[i]
        if (element && element.className && element.topId) {
          classNames[`${element.topId}`] = element.className
        }
      }
      const classData = []
      for (const key in classNames) {
        if (Object.hasOwnProperty.call(classNames, key)) {
          const element = classNames[key]
          classData.push({
            'topId': key,
            'className': element
          })
        }
      }
      return classData
    }
  },
  watch: {
    searchCurrencyMsg() {
      this.searchCurrency()
    },
    marketDetails: {
      handler: function(val, oldVal) {
        const that = this
        if (val && oldVal && val.length && oldVal.length) {
          this.isSame(val, oldVal)
        }
        const showDatam = []
        for (let i = 0; i < val.length; i++) {
          var bfs = val[i]['quotechange']
          val[i]['bfs'] = parseFloat(bfs.substring(0, bfs.length - 1))
          val[i]['priceColor'] = 'transparent'

          showDatam.push(val[i])
        }
        that.newmarketDetailsList = showDatam
        that.computedclassMarkets()
        // if (that.tvReadyFlagsGetter) {
        //   this.computedclassMarkets()
        // }
        if (val && oldVal && val.length !== oldVal.length) {
          that.getIsMain()
        }
      },
      deep: true,
      immediate: true
    },
    newmarketDetails: {
      handler: function(val) {
        // const util.floatAdd
      },
      deep: true,
      immediate: true
    },
    tvReadyFlagsGetter() {
      this.computedclassMarkets()
    },
    selectClass(val) {
      this.computedclassMarkets()
    },
    selfSelectMarketSymbols() {
      this.addSelectTarget()
    },
    isSelfSelectStyle(val) {
      if (val) {
        this.computedclassMarkets()
      }
    },
    isAllSelectStyle(val) {
      if (val) {
        this.computedclassMarkets()
      }
    }
  },
  created() {
    for (let i = 0; i < this.marketDetails.length; i++) {
      this.marketDetails[i].isMain = false
    }
    this.newmarketDetails = this.marketDetails
    this.getIsMain()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.path.indexOf('login') !== -1) {
        // vm.findBankInfo()// 查询签约状态
        vm.sureLogin()
      }
    })
    next()
  },
  mounted() {
    // 获取自选信息
    this.findSymbolMarkList()
    if (this.item || this.marketDetails.length) {
      this.isHeight = this.item ? this.item.symbolId : this.marketDetails[0].symbolId
    }
    const contractIds = []
    for (const i in this.newmarketDetails) {
      if (Object.prototype.hasOwnProperty.call(this.newmarketDetails, i)) {
        const element = this.newmarketDetails[i]
        contractIds.push(element.symbolId)
      }
    }
    hqProtocol.param_subscribe.contractIds = contractIds
    hqWs.send(hqProtocol.param_subscribe)
    // this.sureLogin()
  },
  beforeDestroy() {
    if (this.timeClick) {
      clearInterval(this.timeClick)
    }
    this.timeClick = null
  },
  methods: {
    sureLogin() {
      const firmId = this.$store.state.common.sessionInfo.firmId
      const time = new Date()
      const timer = util.formatnewDay(time)
      const obj = {}
      obj.firmId = firmId
      obj.time = timer
      const content = JSON.parse(localStorage.getItem('userList')) || []
      if (content.length !== 0) {
        let m = 0
        for (let i = 0; i < content.length; i++) {
          if (content[i].firmId === firmId) {
            content.splice(i, 1)
            content.push(obj)
            // if (this.isQianyue) {
            //   this.getMoneyPwdFlgByFirmId()
            // }
          } else {
            m = m + 1
          }
        }
        if (m === content.length) {
          content.push(obj)
          this.$refs.agreementOpen.showDia(592)
        }
      } else {
        content.push(obj)
        this.$refs.agreementOpen.showDia(592)
      }
      // localStorage.setItem('userList', JSON.stringify(content))
      this.userList = content
    },
    confirmAgree(num) {
      // eslint-disable-next-line eqeqeq
      if (num == 1) {
        // 点击的了解详情
        this.$refs.agreementOpen.showDia(592)
      } else {
      // 点击了取消和详情中的确定
        // if (this.isQianyue) {
        //   this.getMoneyPwdFlgByFirmId()
        // }
      }
      localStorage.setItem('userList', JSON.stringify(this.userList))
    },
    // 银行签约信息
    findBankInfo() {
      http.postFront(protocol.param_findBankInfo).then(response => {
        var { code, value, message } = response.data
        if (Number(code) === 0) {
          if (!value) {
            this.isQianyue = false
            return
          }
          if (
            value &&
            value.signFlag &&
            (value.signFlag === 2 || value.signFlag === 8)
          ) {
            // 解约状态
            this.isQianyue = false
          } else {
            // 签约状态
            this.isQianyue = true
          }
        } else {
          this.$message(message)
        }
      })
    },
    // 判断当前用户是否修改过资金密码
    getMoneyPwdFlgByFirmId() {
      const that = this
      http.postFront(protocol.param_getMoneyPwdFlgByFirmId).then(response => {
        const { code, value } = response.data
        if (code === 0 || code === '0') {
          that.$store.commit('setChangeMarginPsd', value)
          if (value === true) {
            that.$alert('登录后请先修改资金密码，否则无法进行交易', '提示', {
              confirmButtonText: '确定',
              callback: action => {
              }
            })
          }
        }
      })
    },
    // 排序后触发
    sortChange({ column, prop, order }) {
      this.sortOrder = order
    },
    // 新排序
    sortChangeF(column) {
      this.$nextTick(
        this.newmarketDetails.sort((a, b) => {
          const uni = column.order === 'descending' // 是否为倒序排序
          // 分类权重
          if (a.classId !== b.classId) {
            return a.classId - b.classId
          }
          // 按主力排序
          let aNum = Number(a.symbolId)
          let bNum = Number(b.symbolId)
          if (a.isMain) {
            aNum = aNum + 100000000
          }
          if (b.isMain) {
            bNum = bNum + 100000000
          }
          return uni ? bNum - aNum : aNum - bNum
        })
      )
    },
    nameStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 3) {
        if (column.order == 'ascending') {
          return 'ascSort'
        } else if (column.order == 'descending') {
          return 'desSort'
        } else {
          return ''
        }
      }
    },
    goTranscc(row) {
      this.$store.commit('item', row)
      const defaultTVStyle = {
        time: 1,
        isFenshi: true,
        buttonid: 0
      }
      localStorage.setItem('__local_defaultTVStyle', JSON.stringify(defaultTVStyle))
      this.$router.push({
        name: 'transcc',
        query: {
          ids: 1
        }
      })
    },
    // 排序
    sorttableF(a, b) {
      let aNum = Number(a.symbolId)
      let bNum = Number(b.symbolId)
      if (a.isMain) {
        aNum = aNum + 100000000
      }
      if (b.isMain) {
        bNum = bNum + 100000000
      }
      // 分类权重
      aNum = aNum + 100000000000 / a.classId
      bNum = bNum + 100000000000 / b.classId
      // if (a.className === '洋葱') {
      //   aNum = aNum + 1000000000
      // }
      // if (b.className === '洋葱') {
      //   bNum = bNum + 1000000000
      // }
      // if (a.className === '土豆') {
      //   aNum = aNum - 1000000000
      // }
      // if (b.className === '土豆') {
      //   bNum = bNum - 1000000000
      // }
      return bNum - aNum
    },
    // 计算当前大类商品 并标注自选状态
    computedclassMarkets() {
      if (this.selectClass.topId) {
        const mArr = []
        for (let i = 0; i < this.newmarketDetailsList.length; i++) {
          const e = this.newmarketDetailsList[i]
          if (e.topId == this.selectClass.topId) {
            mArr.push(e)
          }
        }
        this.newmarketDetails = mArr.map((item, i) => {
          item.index = i
          item._isSelfSelect = false
          return item
        })
      } else {
        const deepCopyMArr = this.newmarketDetailsList && this.newmarketDetailsList.length > 0 ? JSON.parse(JSON.stringify(this.newmarketDetailsList)) : []
        this.newmarketDetails = deepCopyMArr.map((item, i) => {
          item.index = i
          item._isSelfSelect = false
          return item
        })
      }

      // addSelectTarget
      this.addSelectTarget()
    },
    // 是否是主力合约
    getIsMain() {
      http.postFront(protocol.param_findCommodityIsMain).then(res => {
        if (res && res.data) {
          const { code, message, value } = res.data
          if (Number(code) === 0) {
            this.mainList = value ? value.map((i) => { return i.commodityId }) : []
            for (let i = 0; i < this.mainList.length; i++) {
              this.newmarketDetails.forEach((ele) => {
                if (ele.symbolId == this.mainList[i]) {
                  ele.isMain = true
                }
              })
            }
          } else {
            this.$message(message)
          }
        }
      })
    },
    // 添加自选状态标注
    addSelectTarget() {
      const arr = JSON.parse(JSON.stringify(this.newmarketDetails))
      const that = this
      this.newmarketDetails = []
      for (let i = 0; i < arr.length; i++) {
        arr[i].index = i + 1
        if (this.isSelectedGood(arr[i].symbolId)) {
          arr[i]._isSelfSelect = true
        } else {
          arr[i]._isSelfSelect = false
        }
      }
      this.newmarketDetails = arr
      // 筛选自选商品
      if (this.isSelfSelectStyle) {
        const markets = []
        for (let i = 0; i < this.newmarketDetails.length; i++) {
          if (this.newmarketDetails[i]._isSelfSelect) {
            markets.push(JSON.parse(JSON.stringify(this.newmarketDetails[i])))
          }
        }
        this.newmarketDetails = JSON.parse(JSON.stringify(markets))
        // 计算成交量，存货量，成交金额合计
        that.totalAmount = {
          amount: 0, // 成交量
          holdQuantity: 0, // 存货量
          totalAmount: 0 // 成交金额
        }
        // 计算成交量，存货量，成交金额合计
        for (let j = 0; j < this.newmarketDetails.length; j++) {
          const ele = this.newmarketDetails[j]
          this.totalAmount.amount = !isNaN(ele.amount) ? (util.floatAdd(this.totalAmount.amount, ele.amount)) : this.totalAmount.amount
          this.totalAmount.holdQuantity = !isNaN(ele.holdQuantity) ? (util.floatAdd(this.totalAmount.holdQuantity, ele.holdQuantity)) : this.totalAmount.holdQuantity
          this.totalAmount.totalAmount = !isNaN(ele.totalAmount) ? (util.floatAdd(this.totalAmount.totalAmount, ele.totalAmount)) : this.totalAmount.totalAmount
        }
      } else {
        // 计算成交量，存货量，成交金额合计
        that.totalAmount = {
          amount: 0, // 成交量
          holdQuantity: 0, // 存货量
          totalAmount: 0 // 成交金额
        }
        for (let j = 0; j < arr.length; j++) {
          const ele = arr[j]
          this.totalAmount.amount = !isNaN(ele.amount) ? (util.floatAdd(this.totalAmount.amount, ele.amount)) : this.totalAmount.amount
          this.totalAmount.holdQuantity = !isNaN(ele.holdQuantity) ? (util.floatAdd(this.totalAmount.holdQuantity, ele.holdQuantity)) : this.totalAmount.holdQuantity
          this.totalAmount.totalAmount = !isNaN(ele.totalAmount) ? (util.floatAdd(this.totalAmount.totalAmount, ele.totalAmount)) : this.totalAmount.totalAmount
        }
      }
    },
    // 分类选择
    changeSelectClass(i) {
      this.isSelfSelectStyle = false
      this.isAllSelectStyle = false
      if (this.selectClass.topId == i.topId) {
        this.selectClass = {
          'topId': null,
          'className': null
        }
        this.isAllSelectStyle = true
      } else this.selectClass = i
    },
    // 改变自选选中状态
    changeSelfSelect(id) {
      const _this = this
      const staus = this.isSelectedGood(id)
      // 新增自选
      if (!staus) {
        protocol.param_addCommodityFirmMark.param.firmId = Number(this.sessionInfoGetter.firmId)
        protocol.param_addCommodityFirmMark.param.commodityId = Number(id)
        http.postFront(protocol.param_addCommodityFirmMark).then(res => {
          if (res && res.data && res.data.code == 0) {
            if (id) _this.selfSelectMarketSymbols.push(id)
          } else {
            this.$message('添加自选失败')
          }
        })
      } else {
        // 删除自选
        protocol.param_deleteCommodityFirmMark.param.firmId = Number(this.sessionInfoGetter.firmId)
        protocol.param_deleteCommodityFirmMark.param.commodityId = Number(id)
        http.postFront(protocol.param_deleteCommodityFirmMark).then(res => {
          if (res && res.data && res.data.code == 0) {
            if (id && _this.selfSelectMarketSymbols) {
              for (let i = 0; i < _this.selfSelectMarketSymbols.length; i++) {
                const element = _this.selfSelectMarketSymbols[i]
                if (element == id) {
                  _this.selfSelectMarketSymbols.splice(i, 1)
                }
              }
            }
          } else {
            this.$message('删除自选失败')
          }
        })
      }
    },
    // 查询自选状态
    findSymbolMarkList() {
      http.postFront(protocol.param_findSymbolMarkList).then(res => {
        if (res && res.data) {
          const { code, message, value } = res.data
          if (Number(code) === 0) {
            this.selfSelectMarketSymbols = value ? value.map((i) => { return i.commodityId }) : []
          } else {
            this.$message(message)
          }
        }
      })
    },
    // 查询是否为自选
    isSelectedGood(symbolId) {
      if (this.selfSelectMarketSymbols && this.selfSelectMarketSymbols.length > 0) {
        let req = false
        for (let i = 0; i < this.selfSelectMarketSymbols.length; i++) {
          const element = this.selfSelectMarketSymbols[i]
          if (element == symbolId) { req = true }
        }
        return req
      } else {
        return false
      }
      // return this.selfSelectMarketSymbols ? Boolean(this.selfSelectMarketSymbols.find((i) => { return i.symbolId == symbolId })) : false
    },
    // 修改自选状态
    selfSeelctClick(type) {
      this.selectClass = {
        'topId': null,
        'className': null
      }
      this.isAllSelectStyle = false
      this.isSelfSelectStyle = true
      // this.isSelfSelectStyle = !this.isSelfSelectStyle
    },
    allSelectlctClick() {
      this.selectClass = {
        'topId': null,
        'className': null
      }
      this.isSelfSelectStyle = false
      this.isAllSelectStyle = true
      // this.isAllSelectStyle = !this.isAllSelectStyle
    },
    // 存储数据
    markets(row, event, column) {
      this.$store.commit('item', row)
      this.$emit('confirm')
      this.isHeight = row.symbolId
    },
    // 涨幅颜色
    txtClass(row, column, rowIndex, columnIndex) {
      if (row.columnIndex == 1) {
        if (row.row.close > row.row.clearPrice) {
          return 'increaseColor'
        } else if (row.row.close < row.row.clearPrice) {
          return 'dropColor'
        } else {
          return ''
        }
      }
      if (row.columnIndex == 2) {
        if (row.row.quotechange == '0.00%') {
          return ''
        }
        return this.setStrClass(
          row.row.quotechange,
          '-',
          'dropColor',
          'increaseColor'
        )
      }
    },
    txtRowClass(row, column, rowIndex, columnIndex) {
      return row && row.row && row.row.symbolId ? row.row.symbolId + 'infoCoin' : ''
    },
    isSame(arr, arr2) {
      const arr1 = this.oldmarketlists
      if (arr.length !== arr1.length) {
        this.setoldmarketlists(arr)
        return false
      }
      for (let i = 0; i < arr.length; i++) {
        const item = arr[i]
        const item1 = arr1[i]
        if (item['close'] == item1['close']) {
          item.priceColor = 'transparent'
        } else if (item['close'] > item1['close']) {
          item.priceColor = 'red' // lvse
          const container = document.getElementsByClassName(
            item.symbolId + 'infoCoin'
          )
          for (let i = 0; i < container.length; i++) {
            const element = container[i]
            element.classList.add('upflash')
            setTimeout(function() {
              element.classList.remove('upflash')
            }, 500)
          }
        } else {
          item.priceColor = 'green' // 红色
          const container = document.getElementsByClassName(
            item.symbolId + 'infoCoin'
          )
          for (let i = 0; i < container.length; i++) {
            const element = container[i]
            element.classList.add('downflash')
            setTimeout(function() {
              element.classList.remove('downflash')
            }, 500)
          }
        }
      }
      this.setoldmarketlists(arr)
    },
    setoldmarketlists(arr) {
      if (arr && arr.length > 0) {
        this.oldmarketlists = JSON.parse(JSON.stringify(arr))
      } else {
        this.oldmarketlists = []
      }
    },
    // 搜索币种
    searchCurrency() {
      const aSearch = ['search', this.searchCurrencyMsg]
      hqProtocol.param_searchCurrency.symbol = aSearch
      hqWs.send(hqProtocol.param_searchCurrency)
    }
  }
}
</script>
<style lang="scss" scoped>
#quotationListPage {
  position: relative;
  background: #fff;
  min-height: calc(100vh - 60px);
  .quotationTitle {
    padding-top: 39px;
    padding-left: 49px;
    border-bottom: 1px solid #e5e5e5;
    .title {
      display: inline-block;
      font-family: Source Han Sans SC;
      font-weight: bold;
      font-size: 20px;
      color: #333333;
      padding-bottom: 18px;
      border-bottom: 1px solid #707070;
    }
  }
}

.mainForce {
  // position: absolute;
  // right:10px;
  display: inline-block;
  width: 42px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  color: #2382fa;
  border: 1px solid #2382fa;
  border-radius: 2px;
}

.el-icon-star-on:before {
  font-size: 16px;
}

.notFree .el-icon-star-on:before {
  color: #999999;
}

.optional .el-icon-star-on:before {
  color: #999999;
}

.selfSeelctSymbol {
  color: #2382fa !important;
}

.selfSeelctSymbol::before {
  color: #2382fa !important;
}

.centerWrap {
  .goods_choose {
    background: #ffffff;
    padding-left: 49px;
    padding-top: 13px;
    border-bottom: 1px solid #e5e5e5;
  }

  .goods_choose_box {
    display: flex;
    align-items: center;

    .goods_self_choose {
      position: relative;
      font-family: Source Han Sans SC;
      font-weight: bold;
      font-size: 16px;
      color: #999999;
      padding: 19px 0;
      cursor: pointer;
      margin-right: 21px;
      border-bottom: 1px solid transparent;
    }

    .select {
      color: #333333;
      border-color: #707070;
    }
  }

  .amountWrap {
    height: 30px;
    background: #ffffff;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #1b1d24;
    border-top: 1px solid #1b1d24;

    .itemData {
      margin-right: 20px;
      color: #CEE600;
      font-size: 16px;
      line-height: 30px;
    }

  }
}

.transCC-box7 {
  // position: absolute;
  // top: 610px;
  // left: 0;
  width: 100%;
  height: 353px;
}
</style>
<style>

/* 隐藏滚动条 */
#quotationListPage .el-table__body-wrapper::-webkit-scrollbar {
    /* display: none; 对于Webkit浏览器 */
    background-color: #fff !important;
}
#quotationListPage .el-table__body-wrapper::-webkit-scrollbar-thumb {
    /* display: none; 对于Webkit浏览器 */
    background-color: #ccc !important;
}

#quotationListPage .el-table--border::after,
#quotationListPage .el-table--group::after,
.el-table::before {
  background-color: transparent;
}

#quotationListPage .el-table td div {
  text-align: center;
  font-family: Source Han Sans SC;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
}

#quotationListPage .el-table td {
  border-bottom: none
}
#quotationListPage .el-table th.is-leaf {
  padding-top: 9px;
  padding-bottom: 9px;
  border-bottom: 0;
}
#quotationListPage .el-table td,
#quotationListPage .el-table th {
  padding: 4px 0;
}

#quotationListPage .el-table td .goldColor {
  color: #FFD700;
}

#quotationListPage .el-table td .greyColor {
  color: rgba(255, 255, 255, 0.5);
}

#quotationListPage .el-table td .redColor {
  color: #D94066;
}

#quotationListPage .el-table td .greenColor {
  color: #41b37d;
}

#quotationListPage .el-table td .whiteColor {
  color: #666666;
}

#quotationListPage .el-pagination button:disabled,
#quotationListPage .el-pagination .btn-prev,
#quotationListPage .el-pagination .btn-next,
#quotationListPage .el-pager li,
#quotationListPage .el-pagination__editor.el-input .el-input__inner,
#quotationListPage .el-pagination .el-select .el-input .el-input__inner,
#quotationListPage .el-table table tr,
#quotationListPage .el-table th,
#quotationListPage .el-table {
  background: #fff;
}

#quotationListPage .el-table--striped .el-table__body tr.el-table__row--striped.current-row td,
#quotationListPage .el-table__body tr.current-row>td,
#quotationListPage .el-table__body tr.hover-row.current-row>td,
#quotationListPage .el-table__body tr.hover-row.el-table__row--striped.current-row>td,
#quotationListPage .el-table__body tr.hover-row.el-table__row--striped>td,
#quotationListPage .el-table__body tr.hover-row>td,
#quotationListPage .el-table th.el-table__cell {
  background: #fff;
}
#quotationListPage .el-table__row {
  height: 36px;
}
#quotationListPage .el-table__row--striped .el-table__cell {
  background: #FAFAFA;
  background-color: #FAFAFA;
}
#quotationListPage .el-table__row:last-child {
  box-shadow: 0px 5px 7px 1px rgba(0,0,0,0.07);
}
/* #quotationListPage .el-table--enable-row-hover .el-table__body .el-table__row:hover > td {
  background-color: #FFFFFF !important;
}
#quotationListPage .el-table--enable-row-hover .el-table__body .el-table__row--striped:hover > td {
  background-color: #FAFAFA !important;
} */
#quotationListPage .el-table__header-wrapper th>.cell {
  font-family: Source Han Sans SC;
  font-weight: 600;
  font-size: 16px;
  color: #333333;
}


#quotationListPage .el-table__header-wrapper th.ascSort .cell {
  background: url('../../assets/images/ruy.png') no-repeat 50% 50%;
}

#quotationListPage .el-table__header-wrapper th.desSort .cell {
  background: url('../../assets/images/jt1.png') no-repeat 50% 50%;
}

#quotationListPage .el-table .el-table__cell {
  padding: 4px 0;
}

#quotationListPage .el-table td.el-table__cell {
  border: none;
}

</style>
